











































import { Component, Vue } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import Routes from '@/util/Routes';
import LoadingIndicator from '@/views/common/LoadingIndicator.vue';
import AddressList from '@/views/account/user/AddressList.vue';
import { DeliveryMethodDto, OrderDto, OrderFragmentDto, PageMetadataDto, PageRequestDto } from '@/api';
import ShowMorePagination from '@/views/common/ShowMorePagination.vue';
import OrderHistoryStore from '@/stores/order/order-history.store';
import { DateFormatter } from '@/util/DateFormatter';
import { Addresses } from '@/util/Addresses';
import { PriceFormatter } from '@/util/PriceFormatter';
import { CmsStore } from '@/stores/cms.store';
import UserStore from '@/stores/user/user.store';

@Component({
  components: {ShowMorePagination, AddressList, LoadingIndicator},
})
export default class UserOrders extends Vue {
  public orderHistoryStore = getModule(OrderHistoryStore, this.$store);
  private cmsStore = getModule(CmsStore, this.$store);
  private userStore = getModule(UserStore, this.$store);

  public routes = Routes;
  private loading = true;
  private orderFragment: OrderFragmentDto | null = null;

  public async mounted() {
    await this.orderHistoryStore.fetchInitialOrders();

    this.loading = false;
  }

  get orders(): OrderDto[] {
    return this.orderHistoryStore.currentOrders;
  }

  get ordersCount(): number {
    return this.orderHistoryStore.currentOrders?.length;
  }

  get currentPage(): PageMetadataDto {
    return this.orderHistoryStore.currentPage;
  }

  get currentPageRequest(): PageRequestDto {
    return this.orderHistoryStore.currentPageRequest;
  }

  get pickUpLocationText(): string {
    return 'im Einkaufszentrum in Zams';
  }

  public isDelivery(order: OrderDto): boolean {
    return order.deliveryMethod === DeliveryMethodDto.DELIVERY;
  }

  public async fetchAdditionalPage(page: PageMetadataDto): Promise<void> {
    await this.orderHistoryStore.fetchAdditionalPage(page);
  }

  public creationDay(order: OrderDto): string {
    if (order.creationTime) {
      return DateFormatter.formatDate(order.creationTime);
    }
    return '';
  }

  public deliveryDay(order: OrderDto): string {
    if (order.deliverySlotStartTime) {
      return DateFormatter.formatDate(order.deliverySlotStartTime);
    }
    return '';
  }

  public deliveryTime(order: OrderDto): string {
    if (order.deliverySlotStartTime && order.deliverySlotEndTime) {
      return DateFormatter.formatTime(order.deliverySlotStartTime) + ' - '
        + DateFormatter.formatTime(order.deliverySlotEndTime);
    }
    return '';
  }

  public deliveryAddressString(order: OrderDto): string {
    if (order.deliveryAddress) {
      return Addresses.toString(order.deliveryAddress);
    }

    return '';
  }

  public totalPrice(order: OrderDto): string {
    return PriceFormatter.formatPrice(order.totalPrice);
  }
}
